<template>
  <div class="app-layout">
    <div class="app-layout__content">
      <div v-if="!isWidgetLayout" class="app-layout__sidebar-wrapper" :class="{ minimized: isSidebarMinimized }">
        <!-- <div v-if="isFullScreenSidebar" class="flex justify-end">
          <va-button class="px-4 py-4" icon="md_close" preset="plain" color="dark" @click="onCloseSidebarButtonClick" />
        </div> -->
        <sidebar
          :width="sidebarWidth"
          :minimized="isSidebarMinimized"
          :minimized-width="sidebarMinimizedWidth"
          :animated="!isMobile"
          :is-fullscreen="isFullScreenSidebar"
        />
      </div>
      <div class="app-layout__page">
        <navbar v-if="!isWidgetLayout" :class="{ hidden: !isMobile }" />

        <div class="sm:px-2 h-full md:pt-0 pt-12">
          <router-view />
        </div>
      </div>
    </div>
    <business-partner-guide-modal v-if="showGuide"></business-partner-guide-modal>
  </div>
</template>

<script setup>
  import { computed, onBeforeUnmount, onMounted, watch, ref } from 'vue'
  import { storeToRefs } from 'pinia'
  import { onBeforeRouteUpdate } from 'vue-router'
  import Navbar from '@/components/navbar/Navbar.vue'
  import BusinessPartnerGuideModal from '@/components/BusinessPartnerGuideModal.vue'
  import { useGlobalStore } from '../stores/global-store'

  import Sidebar from '../components/sidebar/Sidebar.vue'
  import { useRoute } from 'vue-router'
  const route = useRoute()
  const isWidgetLayout = computed(() => route.query.layout === 'widget')

  const GlobalStore = useGlobalStore()
  const { user } = storeToRefs(GlobalStore)
  const showGuide = ref(false)

  const mobileBreakPointPX = 640
  const tabletBreakPointPX = 768

  const sidebarWidth = ref('14rem')
  const sidebarMinimizedWidth = ref(undefined)

  const isMobile = ref(false)
  const isTablet = ref(false)
  const { isSidebarMinimized } = storeToRefs(GlobalStore)
  const checkIsTablet = () => window.innerWidth <= tabletBreakPointPX
  const checkIsMobile = () => window.innerWidth <= mobileBreakPointPX

  const onResize = () => {
    isSidebarMinimized.value = checkIsTablet()

    isMobile.value = checkIsMobile()
    isTablet.value = checkIsTablet()
    sidebarMinimizedWidth.value = isMobile.value ? '0' : '4.5rem'
    sidebarWidth.value = isTablet.value ? '100%' : '16rem'
  }

  watch(user, () => {
    if (user.value.is_business_partner && localStorage.getItem('businessGuidesPassed') !== 'true') {
      showGuide.value = true
    }
  })

  onMounted(() => {
    window.addEventListener('resize', onResize)
    if (user.value.is_business_partner && localStorage.getItem('businessGuidesPassed') !== 'true') {
      showGuide.value = true
    }
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', onResize)
  })

  onBeforeRouteUpdate(() => {
    if (checkIsTablet()) {
      // Collapse sidebar after route change for Mobile
      isSidebarMinimized.value = true
    }
  })

  onResize()

  const isFullScreenSidebar = computed(() => isTablet.value && !isSidebarMinimized.value)

  // const onCloseSidebarButtonClick = () => {
  //   isSidebarMinimized.value = true
  // }
</script>

<business-partner-guide-modal v-if="showGuide" @close="showGuide = false" />
<style lang="scss">
  $mobileBreakPointPX: 640px;
  $tabletBreakPointPX: 768px;

  .app-layout {
    height: 100vh;
    display: flex;
    flex-direction: column;

    &__navbar {
      min-height: 4rem;
    }

    &__content {
      display: flex;
      height: calc(100vh - 4rem);
      flex: 1;

      @media screen and (max-width: $tabletBreakPointPX) {
        height: calc(100vh - 6.5rem);
      }

      .app-layout__sidebar-wrapper {
        position: relative;
        height: 100%;
        background: #ffffff;

        @media screen and (max-width: $tabletBreakPointPX) {
          &:not(.minimized) {
            width: 100%;
            height: 100%;
            position: fixed;
            top: 0;
            z-index: 999;
          }

          .va-sidebar:not(.va-sidebar--minimized) {
            .va-sidebar__menu {
              padding: 0;
            }
          }
        }
      }
    }

    &__page {
      position: relative;
      flex-grow: 2;
      overflow-y: overlay;
      background: #ffffff;
      scrollbar-width: thin;
      scrollbar-color: rgba(0, 0, 0, 0.5) transparent;
      /* This property helps prevent reserving extra space for the scrollbar */

      &::-webkit-scrollbar {
        position: absolute;
        width: 4px;
        height: 4px;
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 2px;
      }
    }
  }
</style>
